import axios from "@/plugins/axiosInstance";
import { dashboard } from "@/networking/urlManager";
import { responseHandlerService } from "@/plugins/responseHandlerService";

export async function fetchRealtimeData(assetId) {
  try {
    console.log(assetId,'assetId');
    const params = {
      assetId: assetId,
    };

    // Gerçek zamanlı analytics endpoint'i
    const response = await axios.get(dashboard.getRealtimeAnalytics, {
      params,
    });

    console.log("Gerçek zamanlı veriler:", response.data.data);

    if (response.data && response.data.data) {
      const analyticsData = response.data.data;

      return {
        data: analyticsData,
        isAuthorized: analyticsData.authorized !== false,
        hasPropertyId: analyticsData.hasPropertyId !== false,
        error: null,
      };
    }

    return {
      data: null,
      isAuthorized: true,
      hasPropertyId: true,
      error: null,
    };
  } catch (error) {
    console.error("Gerçek zamanlı veri çekme hatası:", error);

    return {
      data: null,
      isAuthorized: error.response?.data?.data?.authorized !== false,
      hasPropertyId: error.response?.data?.data?.hasPropertyId !== false,
      error: error,
    };
  }
}
